import {
  SITE_FALLBACK_NAME,
  SITE_FALLBACK_URL,
} from "@AdbhutByte/utils/universalModifiers";

export type profileProps = {
  visible: boolean;
  name: string;
  prefix: string;
  username: string;
  icon: string;
  mui_icon: string | false;
  order: number;
  brand_name: string;
};

const baseUrl = process.env.NEXT_PUBLIC_URL ?? SITE_FALLBACK_URL;
const baseName = process.env.NEXT_PUBLIC_SITE_NAME ?? SITE_FALLBACK_NAME;

const fetchProfiles = (): Promise<profileProps[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const profiles: Array<profileProps> = [
        {
          visible: true,
          name: "facebook",
          prefix: "https://www.facebook.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/facebook.png",
          mui_icon: "facebook",
          order: 4,
          brand_name: "Facebook",
        },
        {
          visible: true,
          name: "instagram",
          prefix: "https://www.instagram.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/instagram.png",
          mui_icon: "instagram",
          order: 2,
          brand_name: "Instagram",
        },
        {
          visible: true,
          name: "threads",
          prefix: "https://www.threads.net/@",
          username: "mrasadatik",
          icon: "/reserved/icons/social/threads.png",
          mui_icon: false,
          order: 5,
          brand_name: "Threads",
        },
        {
          visible: false,
          name: "twitter",
          prefix: "https://www.twitter.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/x.png",
          mui_icon: "twitter",
          order: 6,
          brand_name: "X",
        },
        {
          visible: true,
          name: "x",
          prefix: "https://www.twitter.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/x.png",
          mui_icon: "twitter",
          order: 6,
          brand_name: "X",
        },
        {
          visible: true,
          name: "linkedin",
          prefix: "https://www.linkedin.com/in/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/linkedin.png",
          mui_icon: "linkedin",
          order: 3,
          brand_name: "LinkedIn",
        },
        {
          visible: true,
          name: "github",
          prefix: "https://www.github.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/github.png",
          mui_icon: "github",
          order: 1,
          brand_name: "GitHub",
        },
        {
          visible: true,
          name: "youtube",
          prefix: "https://www.youtube.com/@",
          username: "mrasadatik",
          icon: "/reserved/icons/social/youtube.png",
          mui_icon: "youtube",
          order: 9,
          brand_name: "YouTube",
        },
        {
          visible: true,
          name: "behance",
          prefix: "https://www.behance.net/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/behance.png",
          mui_icon: false,
          order: 12,
          brand_name: "Behance",
        },
        {
          visible: true,
          name: "dribbble",
          prefix: "https://www.dribbble.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/dribbble.png",
          mui_icon: false,
          order: 11,
          brand_name: "Dribbble",
        },
        {
          visible: true,
          name: "telegram",
          prefix: "https://www.t.me/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/telegram.png",
          mui_icon: "telegram",
          order: 8,
          brand_name: "Telegram",
        },
        {
          visible: true,
          name: "discord",
          prefix: "https://www.discord.com/users/",
          username: "829560693833334864",
          icon: "/reserved/icons/social/discord.png",
          mui_icon: false,
          order: 7,
          brand_name: "Discord",
        },
        {
          visible: true,
          name: "snapchat",
          prefix: "https://www.snapchat.com/add/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/snapchat.png",
          mui_icon: false,
          order: 15,
          brand_name: "Snapchat",
        },
        {
          visible: true,
          name: "reddit",
          prefix: "https://www.reddit.com/user/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/reddit.png",
          mui_icon: "reddit",
          order: 10,
          brand_name: "Reddit",
        },
        {
          visible: true,
          name: "pinterest",
          prefix: "https://www.pinterest.com/",
          username: "mrasadatik",
          icon: "/reserved/icons/social/pinterest.png",
          mui_icon: "pinterest",
          order: 13,
          brand_name: "Pinterest",
        },
        {
          visible: true,
          name: "quora",
          prefix: "https://www.quora.com/profile/",
          username: "Asaduzzaman-Atik",
          icon: "/reserved/icons/social/quora.png",
          mui_icon: false,
          order: 14,
          brand_name: "Quora",
        },
      ];
      resolve(profiles);
    }, 1000);
  });
};

const getProfilesToFollow = async (
  match?: string
): Promise<boolean | profileProps | profileProps[]> => {
  const profiles = await fetchProfiles();
  let profileToFollow: profileProps | false = false;
  if (match) {
    profiles.forEach((profile) => {
      if (profile.name === match) {
        profileToFollow = profile;
      }
    });
    return profileToFollow;
  } else {
    return profiles;
  }
};

export const getProfileList = async (brand: boolean = false) => {
  const profiles = await getProfilesToFollow();
  if (brand) {
    return (profiles as profileProps[]).map((profile) => profile.brand_name);
  } else {
    return (profiles as profileProps[]).map((profile) => profile.name);
  }
};

export const getProfileLinkList = async (suffix: boolean = false) => {
  const profiles = await getProfilesToFollow();
  const suffix_ = "?ref=" + baseUrl + "&utm_source=" + baseName;
  if (suffix) {
    return (profiles as profileProps[]).map(
      (profile) => profile.prefix + profile.username + "/" + suffix_
    );
  } else {
    return (profiles as profileProps[]).map(
      (profile) => profile.prefix + profile.username
    );
  }
};

export default getProfilesToFollow;
